export enum FormationEnum {
  F_41212 = '4-1-2-1-2',
  F_433 = '4-3-3',
}